export default __webpack_public_path__ + "static/media/bg_1.aad478a7.jpg";